var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 21 18",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M8.05859 8C10.2677 8 12.0586 6.20914 12.0586 4C12.0586 1.79086 10.2677 0 8.05859 0C5.84945 0 4.05859 1.79086 4.05859 4C4.05859 6.20914 5.84945 8 8.05859 8Z",
        },
      }),
      _c("path", {
        attrs: {
          d: "M8.40859 10.01C5.67859 9.91002 0.0585938 11.27 0.0585938 14V16H9.59859C7.12859 13.24 8.36859 10.11 8.40859 10.01Z",
        },
      }),
      _c("path", {
        attrs: {
          d: "M17.4886 14.02C17.8486 13.43 18.0586 12.74 18.0586 12C18.0586 9.79 16.2686 8 14.0586 8C11.8486 8 10.0586 9.79 10.0586 12C10.0586 14.21 11.8486 16 14.0586 16C14.7986 16 15.4886 15.78 16.0786 15.43L18.6486 18L20.0586 16.59L17.4886 14.02ZM14.0586 14C12.9586 14 12.0586 13.1 12.0586 12C12.0586 10.9 12.9586 10 14.0586 10C15.1586 10 16.0586 10.9 16.0586 12C16.0586 13.1 15.1586 14 14.0586 14Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }